import React from 'react';
import { Link, useCreatePath } from 'react-admin';

type ResourceLinkProps = (
  | React.PropsWithChildren<{
      name: string;
      type?: 'show' | 'edit';
      id: string;
    }>
  | React.PropsWithChildren<{
      name: string;
      type: 'list';
      id?: never;
    }>
) & {
  target?: string;
  rel?: string;
};

export const ResourceLink: React.FC<ResourceLinkProps> = ({
  name,
  id,
  type = 'show',
  children,
  target,
  rel,
}) => {
  const createPath = useCreatePath();

  return (
    <Link
      to={createPath({ resource: name, type, id })}
      target={target}
      rel={rel}
    >
      {children}
    </Link>
  );
};
